<template>
  <section class="n4-portada" v-if="B">
    <div class="n2-contenedor">
      <h1 class="n4-portada__titulo" v-html="B.Titulo?.Texto || NOTARIA.Nombre"></h1>

      <div class="n4-portada__rejilla">
        <!-- Foto (o vídeo) del banner, con pie de foto -->
        <figure v-if="media" class="n4-portada__foto">
          <video v-if="esVideo" :src="media" muted autoplay playsinline loop preload="metadata" aria-hidden="true"></video>
          <img v-else :src="media" alt="" fetchpriority="high" :style="{ filter: B.ImagenFiltro || undefined }" />
          <figcaption>{{ [NOTARIA.Nombre, C.Municipio].filter(Boolean).join(' · ') }}</figcaption>
        </figure>

        <div class="n4-portada__lateral">
          <p v-if="B.Subtitulo?.Texto" class="n4-portada__entradilla" v-html="B.Subtitulo.Texto"></p>
          <div v-if="B.Texto?.Texto" class="n4-portada__parrafo" v-html="B.Texto.Texto"></div>
          <div class="n4-portada__botones">
            <button v-if="B.ShowButtonMoveMenu && B.ButtonMoveMenu?.Texto" type="button" class="n2-boton n2-boton--acento n2-boton--grande"
              @click="ir(B.ButtonMoveMenu.Click, false)">{{ B.ButtonMoveMenu.Texto }}</button>
            <button v-if="B.ShowButtonMoveInicio && B.ButtonMoveInicio?.Texto" type="button" class="n4-boton-texto"
              @click="ir(B.ButtonMoveInicio.Click, true)">{{ B.ButtonMoveInicio.Texto }} <span aria-hidden="true">→</span></button>
          </div>

          <!-- Ficha con lo que más se busca -->
          <dl v-if="C.Telefono || C.Direccion || C.Horario" class="n4-ficha">
            <div v-if="C.Telefono">
              <dt>{{ tSolicitud('Llamar') }}</dt>
              <dd><a class="n4-ficha__telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')">{{ C.Telefono.trim() }}</a></dd>
            </div>
            <div v-if="C.Direccion">
              <dt>{{ tituloSeccion(NOTARIA, 'Contacto', $t) }}</dt>
              <dd><a :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">{{ C.Direccion }}<br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}</a></dd>
            </div>
            <div v-if="C.Horario">
              <dt>
                {{ T.Footer?.TituloHorario?.Texto || tSolicitud('Horario') }}
                <span v-if="abierto !== null" class="n2-estado" :class="abierto ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
                  <span class="n2-estado__punto"></span>{{ tSolicitud(abierto ? 'Abierto ahora' : 'Cerrado ahora') }}
                </span>
              </dt>
              <dd class="n2-pre">{{ C.Horario }}</dd>
            </div>
          </dl>
        </div>
      </div>

      <!-- Sumario: las secciones de la portada que están activas, numeradas como en una revista -->
      <nav v-if="secciones.length > 1" class="n4-sumario" :aria-label="tSolicitud('Sumario')">
        <a v-for="s in secciones" :key="s.ancla" :href="'#' + s.ancla" @click.prevent="irA(s.ancla)">
          <span class="n4-sumario__num">{{ numero(s.ancla) }}</span>{{ s.texto }}
        </a>
      </nav>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { useAccionBanner, tituloSeccion, abiertoAhora } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile, $t } = useUtils()
const ir = useAccionBanner()
const { secciones, numero } = useSumario()

// Panel: Inicio → Banner (mismos textos, imagen o vídeo y botones)
const B = computed(() => NOTARIA.value?.Theme?.Home?.Banner)
const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const esVideo = computed(() => getFile(B.value?.Imagen)?.type === 'video/mp4')
const media = computed(() => B.value?.Imagen ? imagenIDtoSRC(B.value.Imagen) : '')

// Depende de la hora del visitante: solo en el navegador
const abierto = ref(null)
onMounted(() => { abierto.value = abiertoAhora(C.value.HorarioEstructurado) })

function irA(ancla) {
  const el = document.getElementById(ancla)
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' })
}
</script>
